/* eslint semi:0 */
import { path, } from '../../jsCore/utils/ua'
import { connect, } from 'react-redux'
import humanFormat from 'human-format'
import React, { PropTypes, } from 'react'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { queryString, } from '../../jsCore/utils/window'
import { info, } from '../../jsCore/application/console'
import { StatsItem, } from './components/StatsItem'
import { StatsWrapper, } from './components/StatsWrapper'
import { postMetadataReducer, } from './postMetadataReducer'
import { postMetadataActions, } from './postMetadataActions'
import { MOUNT_POINTS, } from '../../jsCore/config/preRenderedSelectorsConfig'
import { isSupportedForDomain, } from '../../jsCore/application/pageDataObject'


const POST_METADATA_STATS_FEATURE_ID = 'PostMetadataStats'
const COMPONENT_NAME = 'statsContainer'
const STATE_KEY = 'postMetadataStats'
const {
  showReadsCounter: shouldDisplayPostStatsInEmbedLayout,
  debugPostStats
} = queryString
const statsBemModifiers = {
  reads: 'view',
  shares: 'share',
}

const { isEmbedded, } = path


function formatNumber(number, opts){
  return humanFormat(Number(number), opts)
}

function statItemView(stat, modifier, key){
  const statsItemProps = {
    key,
    modifier,
    children: formatNumber(stat, { decimals: 0, }),
  }
  return <StatsItem { ...statsItemProps }/>
}

function getStats(stats, modifiers){
  return Object
    .entries(stats)
    .map(
      ([statName, stat], index) => statItemView(stat, modifiers[statName], index)
    )
}

class PostMetadataStats extends React.Component {

  componentWillMount(){
    const { IS_OVERRIDE, fetchData, } = this.props
    if (!IS_OVERRIDE) {
      fetchData()
    }
  }

  render(){
    const { stats, } = this.props
    if (debugPostStats) {
      info('[QS] Rendering component with: ', stats)
    }
    return <StatsWrapper>{ getStats(stats, statsBemModifiers) }</StatsWrapper>
  }
}

function definePropTypes(component){
  const { number, bool, shape, func, } = PropTypes
  component.propTypes = {
    stats: shape({
      views: number,
      shares: number,
    }),
    IS_INITIALIZED: bool,
    IS_OVERRIDE: bool,
    mountAction: func,
  }
  return component
}

function mapStatsStateToProps(state){
  const { stats, IS_OVERRIDE, } = state[STATE_KEY]
  return { stats, IS_OVERRIDE, }
}

export const postMetadataStatsContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStatsStateToProps, postMetadataActions)(definePropTypes(PostMetadataStats)),
  reducer: postMetadataReducer,
}

function shouldMountPostMetadataStats(){
  return isSupportedForDomain(POST_METADATA_STATS_FEATURE_ID) && !isEmbedded || shouldDisplayPostStatsInEmbedLayout
}

function mountPostMetadataStats(){
  return reduxMount({
    [MOUNT_POINTS.POST_METADATA_STATS]: postMetadataStatsContainer,
  })
}

export default function initPostMetadataStats(){
  const shouldMountPostMetadata = shouldMountPostMetadataStats()
  if (shouldMountPostMetadata) {
    mountPostMetadataStats()
  }
  return shouldMountPostMetadata
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/post_metadata/postMetadataContainer.js